<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 0C9.55229 0 10 0.447715 10 1V10.5858L12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289C14.0976 8.68342 14.0976 9.31658 13.7071 9.70711L9.70711 13.7071C9.31658 14.0976 8.68342 14.0976 8.29289 13.7071L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L8 10.5858V1C8 0.447715 8.44772 0 9 0ZM1 12C1.55228 12 2 12.4477 2 13V14C2 14.5304 2.21071 15.0391 2.58579 15.4142C2.96086 15.7893 3.46957 16 4 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13V14C18 15.0609 17.5786 16.0783 16.8284 16.8284C16.0783 17.5786 15.0609 18 14 18H4C2.93913 18 1.92172 17.5786 1.17157 16.8284C0.421427 16.0783 0 15.0609 0 14V13C0 12.4477 0.447715 12 1 12Z"
    />
  </svg>

</template>

<script lang="ts">
export default {
  name: "IconDotsVertical",
  props: ["height", "width"],
}
</script>
